module.exports = __webpack_public_path__ + "public/images/purple_lines_top_left.cd894aa2f011541066db996717888652.png";